export default __webpack_public_path__ + "static/media/not_signed_in_hover.6376fc37.svg";